import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import ActionRemove from 'material-ui/svg-icons/action/delete';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import _ from 'lodash';

import ResourceInput from '../../ResourceInput';
import { toArray, id } from '../../../utils/helper';

import styles from './styles';

const groupResources = (resources = {}) => {
  const allResources = toArray(resources);

  return allResources.map((res) => _.assign({ quantity: 1 }, res));
};

class ResourcesTable extends Component {
  static propTypes = {
    // initialDate: PropTypes.object,
    resources: PropTypes.array.isRequired,
    // onEdit: PropTypes.func.isRequired,
    // onRemove: PropTypes.func,
    onChange: PropTypes.func.isRequired,
  };

  state = {};

  handleAddResource = (spec) => {
    console.log('handleAddResource', spec);
    const resources = _.range(spec.quantity).map(() => _.assign({}, _.omit(spec, ['quantity']), { id: id() }));
    console.log('adding resources', resources);
    this.props.onChange((this.props.resources || []).concat(resources));
  };

  handleRemoveResource = (resource) => {
    console.log('handleRemoveResource', resource);
    this.props.onChange(this.props.resources.filter((r) => r.id !== resource.id));
  };

  handleResetResource = (state) => _.assign(_.pick(state, ['role', 'start', 'end', 'quantity']), { date: null });

  renderNoResources() {
    return (<TableRow key="nodata">
      <TableRowColumn colSpan={5} style={styles.noDataRow}>
        <FontIcon className="material-icons" style={styles.noData}>person</FontIcon>
        <div>No resources assigned</div>
      </TableRowColumn>
    </TableRow>);
  }

  renderResource(resource) {
    return (<TableRow key={resource.id}>
      <TableRowColumn>{moment(resource.from).format('ll')}</TableRowColumn>
      <TableRowColumn>{moment(resource.from).format('LT')} - {moment(resource.to).format('LT')}</TableRowColumn>
      <TableRowColumn>{resource.role.name}</TableRowColumn>
      <TableRowColumn style={styles.resourceQuantityCol}>{resource.quantity}</TableRowColumn>
      <TableRowColumn style={styles.resourceActionCol}>
        <IconButton
          tooltip="Remove"
          tooltipPosition="bottom-center"
          onClick={() => this.handleRemoveResource(resource)}
        >
          <ActionRemove />
        </IconButton>
      </TableRowColumn>
    </TableRow>);
  }

  render() {
    const resources = groupResources(this.props.resources);

    return (
      <div>
        <ResourceInput onAdd={this.handleAddResource} onReset={this.handleResetResource}/>
        <Table selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn>Date</TableHeaderColumn>
              <TableHeaderColumn>Hours</TableHeaderColumn>
              <TableHeaderColumn>Role</TableHeaderColumn>
              <TableHeaderColumn style={styles.resourceQuantityCol}>Quantity</TableHeaderColumn>
              <TableHeaderColumn style={styles.resourceActionCol}></TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            { resources.length > 0 ? resources.map((resource) => this.renderResource(resource)) : this.renderNoResources() }
          </TableBody>
        </Table>
      </div>);

  }
}

export default ResourcesTable;



// WEBPACK FOOTER //
// ./src/components/CreateJobDialog/ResourcesTable/index.js